// Single source of truth for CASS business information.
// Confirmed authoritative opening hours: Monday–Friday 08:30–17:00 (CASS, 31 Aug 2026).
// Every visible occurrence (header, footer, contact page) and the structured data
// must read from here so the site can never contradict itself again.
export const BUSINESS_HOURS_LABEL = "Mon – Fri, 08:30 – 17:00";
export const BUSINESS_HOURS_OPENS = "08:30";
export const BUSINESS_HOURS_CLOSES = "17:00";

export const OPENING_HOURS_SPEC = [
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: BUSINESS_HOURS_OPENS,
    closes: BUSINESS_HOURS_CLOSES,
  },
];
